import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import type { LacUser } from '../../types/lac';
import { LacUserProfileFormFields } from './LacUserProfileFormFields';
import { useLacUserProfileForm } from './useLacUserProfileForm';
import './CreateLacUserDialog.css';
import './LacUserProfilePage.css';

export type LacUserProfileFormProps = {
  profile: LacUser;
  tenantName: string;
  userRef: string;
  tenantDisplayName: string;
};

export function LacUserProfileForm({
  profile,
  tenantName,
  userRef,
  tenantDisplayName,
}: LacUserProfileFormProps) {
  const form = useLacUserProfileForm({
    profile,
    tenantName,
    userRef,
  });

  return (
    <form className="lac-user-profile__form" onSubmit={form.handleSubmit}>
      <div className="lac-user-profile__card">
        <LacUserProfileFormFields
          tenantDisplayName={tenantDisplayName}
          roleFieldId={form.roleFieldId}
          role={form.role}
          roleOptions={form.roleOptions}
          onRoleChange={form.handleRoleChange}
          isRoleLoading={form.isRoleLoading}
          isRoleLoadError={form.isRoleLoadError}
          email={form.email}
          onEmailChange={form.setEmail}
          isEmailInvalid={form.isEmailInvalid}
          username={form.username}
          firstName={form.firstName}
          onFirstNameChange={form.setFirstName}
          lastName={form.lastName}
          onLastNameChange={form.setLastName}
          validFrom={form.validFrom}
          onValidFromChange={form.setValidFrom}
          validTo={form.validTo}
          onValidToChange={form.setValidTo}
          isValidToBeforeValidFrom={form.isValidToBeforeValidFrom}
          photoFieldId={form.photoFieldId}
          photoDisplaySrc={form.photoDisplaySrc}
          photoError={form.photoError}
          isPhotoBusy={form.isPhotoBusy}
          isBusy={form.isBusy}
          isSubmitting={form.isSubmitting}
          onPhotoChange={form.handlePhotoChange}
          onRemovePhoto={form.handleRemovePhoto}
        />

        <div className="lac-user-profile__actions">
          {form.isDirty ? (
            <LiksButton
              type="button"
              variant="secondary"
              disabled={form.isBusy}
              onClick={form.handleCancel}
            >
              {form.translate('lac.users.profile.cancel')}
            </LiksButton>
          ) : null}
          <LiksButton type="submit" disabled={form.isSaveDisabled}>
            {form.translate('lac.users.profile.save')}
          </LiksButton>
        </div>
      </div>
    </form>
  );
}
